<div class="flex flex-col gap-2 mx-1">
    <div class="flex flex-col px-4 py-6 bg-on-primary rounded-xl z-0">
        <div class="flex items-center gap-2 mb-4">
            <app-main-title
                iconColor="text-custom-blue"
                iconSize="xl"
                titleSize="text-2xl font-medium"
                [icon]="['far', ActionsEnum.AI]"
                [title]="'artificialIntelligence' | transloco" />
        </div>
    </div>

    <app-connie />
</div>
